import React from "react";
import { Skeleton } from "./Skeleton";

/**
 * Skeleton for Receivables Aging section (title, total, 4 bar buckets, legend row).
 */
export function ReceivablesAgingSectionSkeleton() {
  return (
    <div className="flex h-full min-h-0 w-full min-w-0 flex-col items-start gap-6 rounded-lg border border-solid border-neutral-200 bg-white px-6 py-6 shadow-sm">
      <div className="flex w-full shrink-0 flex-col items-start gap-1">
        <span className="text-heading-3 font-heading-3 text-neutral-900">
          Receivables Aging
        </span>
        <Skeleton className="h-4 w-56" />
        <Skeleton className="h-4 w-32" />
      </div>
      <div className="flex min-h-0 w-full flex-1 flex-col justify-end gap-6 pb-8">
        <div className="flex w-full flex-col items-start gap-0.5 pt-2">
          <div className="flex h-64 min-h-[16rem] w-full flex-none items-end gap-2 md:h-72 md:min-h-[18rem]">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="flex flex-1 flex-col items-center gap-2">
                <Skeleton className="h-6 w-12 rounded" />
                <Skeleton className="min-h-6 w-1 flex-1 rounded" />
              </div>
            ))}
          </div>
          <div className="flex w-full items-start gap-4 mt-3">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="flex flex-1 flex-col items-start gap-1 overflow-hidden"
              >
                <Skeleton className="h-1 w-full rounded-full" />
                <Skeleton className="h-4 w-12 mt-2" />
                <Skeleton className="h-3 w-8" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
